import { Box } from '@mui/material';

import DetailsItem from '../../../../../../common/details-item';
import { formatDateToClientFormat } from '../../../../../../../constants/helpers/dates';
import { reportDetailsFilterValuesFormatter } from '../../../../../../../utils/details';

import locales from '../locales';
import { SmsReportDetailsMetadataResponse } from '../interfaces';

interface Props {
  filters: SmsReportDetailsMetadataResponse;
}

const FilterDetails = ({ filters }: Props) => (
  <Box>
    <DetailsItem
      label={locales.details.startingDate.label}
      value={formatDateToClientFormat({ date: filters.timeRange.from })}
    />
    <DetailsItem
      label={locales.details.endDate.label}
      value={formatDateToClientFormat({ date: filters.timeRange.to, type: 'exclusive' })}
    />
    <DetailsItem
      label={locales.details.operators.label}
      value={reportDetailsFilterValuesFormatter(filters.operators)}
    />
    <DetailsItem label={locales.details.statuses.label} value={reportDetailsFilterValuesFormatter(filters.statuses)} />
    <DetailsItem
      label={locales.details.operationIds.label}
      value={reportDetailsFilterValuesFormatter(filters.operationIds)}
    />
    <DetailsItem
      label={locales.details.recipientMsisdns.label}
      value={reportDetailsFilterValuesFormatter(filters.recipientMsisdns)}
    />
  </Box>
);

export default FilterDetails;
